import React from 'react';
import '../styles/research.css'
import research from '../assets/research.png'
import icon1 from '../assets/s1.png'

const Research =()=>{

    return(

        <div className='research'>
            <div className='research-inner'>
            <h4 style={{color:'#FFD52B'}}>Our Research & Development (R&D)</h4>
            <hr></hr>
            <h1 style={{fontWeight:'600',marginTop:'2rem'}}>Innovating for a Smarter Future</h1>
            <p style={{width:'85%' ,color:'white',fontSize:'0.9rem'}}>Our Research & Development (R&D) team is at the heart of Company Six Robotics, driving innovation and technological excellence. With expertise in cutting-edge fields such as Artificial Intelligence, Machine Learning, Internet of Things (IoT), and Advanced Robotics, our R&D team transforms visionary concepts into practical, groundbreaking solutions.</p>
            <div className='row' style={{display:'flex', marginTop:'20px'}}>
            <div className='col-12 col-md-6'>
                <img src={research} width='100%' height='100%' style={{objectFit:'contain'}}></img>
            </div>
            <div className='col-12 col-md-6'>
            <h1 style={{fontWeight:'600',marginTop:'1rem'}}>Core Focus Areas</h1>
            <div className=''>
                    <div className='myservices' style={{display:'flex',padding:'1rem', height:'33%',gap:'10px'}}>
                        <div className='benefits-icon'>
                            <img src={icon1} width='35px' height='35px' ></img>
                        </div>
                        <div className='benefits-msg' style={{textAlign:'left'}}>
                            <h4>Artificial Intelligence (AI) & (ML)</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Developing intelligent systems capable of learning, adapting, and performing complex tasks autonomously</p>
                        </div>
                    </div>
                    <div className='myservices' style={{display:'flex',padding:'1rem',gap:'10px'}}>
                        <div className='benefits-icon'>
                            <img src={icon1} width='35px' height='35px' ></img>
                        </div>
                        <div className='benefits-msg' style={{textAlign:'left'}}>
                            <h4>Automation Systems</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Crafting bespoke solutions tailored to industries like manufacturing, logistics, and healthcare.</p>
                        </div>
                    </div>
                    <div className='myservices' style={{display:'flex',padding:'1rem',gap:'10px'}}>
                        <div className='benefits-icon'>
                            <img src={icon1} width='35px' height='35px' ></img>
                        </div>
                        <div className='benefits-msg' style={{textAlign:'left'}}>
                            <h4>Cyber-Physical Systems</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Integrating physical and digital systems to create seamless automation workflows.</p>
                        </div>
                    </div>
                    <div className='myservices' style={{display:'flex',padding:'1rem',gap:'10px'}}>
                        <div className='benefits-icon'>
                            <img src={icon1} width='35px' height='35px' ></img>
                        </div>
                        <div className='benefits-msg' style={{textAlign:'left'}}>
                            <h4>Sustainability in Robotics:</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Designing energy-efficient solutions that minimize environmental impact.</p>
                        </div>
                    </div>

                </div>
            
            </div>
            </div>
            <h1 style={{fontWeight:'600',marginTop:'2rem'}}>Team Mission</h1>
            <p style={{width:'85%' ,color:'white',fontSize:'0.9rem'}}>Our R&D team collaborates with universities, research institutes, and industry leaders worldwide to develop technologies that enhance efficiency, safety, and innovation in robotics. From prototyping new machines to deploying AI-enhanced platforms, we aim to revolutionize how industries operate.</p>
            
        </div>
        </div>
    );

}

export default Research;